export default __webpack_public_path__ + "static/media/image08.c072f583.jfif";